import api from './api';

export const callbackService = {
  getAll: (params = {}) => api.get('/callbacks/', { params }),
  getById: (id) => api.get(`/callbacks/${id}`),
  create: (data) => api.post('/callbacks/', data),
  update: (id, data) => api.put(`/callbacks/${id}`, data),
  delete: (id) => api.delete(`/callbacks/${id}`),
};
